export default [{
    header: 'Noticias',
    icon: 'GlobeIcon',
    children: [{
        title: 'Lista',
        route: 'news',
        icon: 'ListIcon'
    }, {
        title: 'Agregar',
        route: 'news-create',
        icon: 'MousePointerIcon'
    }]
}];
